export const TimeSheetDetailsMutations = {
  SetLoading: 'SetLoading',
  RetrieveTimeSheetSuccess: 'RetrieveTimeSheetSuccess',
  ResetTimeSheetState: 'ResetTimeSheetState',
  SetAttachmentsLoading: 'SetAttachmentsLoading',
  RetrieveAttachmentsSuccess: 'RetrieveAttachmentsSuccess',
  RetrieveHistorySuccess: 'RetrieveHistorySuccess',
  ConfirmIbmEndClientSuccess: 'ConfirmIbmEndClientSuccess',
  ChangeIbmEndClientSuccess: 'ChangeIbmEndClientSuccess'
};

export const TimeSheetDetailsActions = {
  RetrieveTimeSheet: 'RetrieveTimeSheet',
  SaveTimeSheet: 'SaveTimeSheet',
  ReopenTimeSheet: 'ReopenTimeSheet',
  TimeSheetApproverAction: 'TimeSheetApproverAction',
  ResetCurrentTimeSheet: 'ResetCurrentTimeSheet',
  RetrieveTimeSheetAttachments: 'RetrieveTimeSheetAttachments',
  ExpenseAction: 'ExpenseAction',
  ConfirmIbmEndClient: 'ConfirmIbmEndClient',
  ChangeIbmEndClient: 'ChangeIbmEndClient',
  RetrieveTimeSheetHistory: 'TimeSheetDetailsActions.RetrieveTimeSheetHistory'
};
export const TimeSheetDetailsGetters = {
  IsLoading: 'isLoading'
};
